import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface ClearFiltersButtonProps {
  onClick: Handler;
}

/*
 * Styles.
 */

const StyledButtonContainerDiv = styled.div`
  display: flex;
`;

/*
 * Component.
 */

export const ClearFiltersButton: FC<ClearFiltersButtonProps> = ({onClick}) => (
  <StyledButtonContainerDiv>
    <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.SMALL} onClick={onClick}>
      <Trans id="filters-clear-all-button-text">Clear all</Trans>
    </Button>
  </StyledButtonContainerDiv>
);
